{
  "validation.required": "{{label}} es un campo obligatorio",
  "validation.minLength": "{{label}} debe tener al menos {{min}} caracteres",
  "validation.maxLength": "{{label}} no puede tener más de {{max}} caracteres",
  "validation.contentTypeAlphanumeric": "{{label}} debe ser alfanumérico",
  "validation.contentTypeDate": "{{label}} debe ser una fecha",
  "validation.contentTypeDateBefore": "{{label}} debe ser una fecha anterior a {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} debe ser una fecha posterior a {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} debe ser una fecha y una hora",
  "validation.contentTypeDatetimeBefore": "{{label}} debe ser una fecha anterior a {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} debe ser una fecha posterior a {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} debe ser un correo electrónico",
  "validation.contentTypeInteger": "{{label}} debe ser un número",
  "validation.contentTypeNumber": "{{label}} debe ser un número",
  "validation.contentTypeRegex": "{{label}} tiene un formato incorrecto",
  "validation.contentTypeText": "{{label}} debe ser un texto",
  "validation.contentTypeTime": "{{label}} debe ser una hora",
  "validation.contentTypeUrl": "{{label}} debe ser una dirección web",
  "select-element.default-option": "Seleccione…",
  "button-element.network-required": "Actualmente estás desconectado. Establece una conexión de red para continuar."
}